
















































































































import { Component, Vue, Watch } from "vue-property-decorator";

import { TravelCalculateForm } from "@/types/all";

import travelPurposes from "@/data/TravelPurposes";
import travelAmounts from "@/data/TravelAmounts";
import travelCovidCoverages from "@/data/TravelCovidCoverage";

import Api from "@/api/travel.api";
import { EventBus, BusEvents } from "@/plugins/event-bus";
import moment from "moment";

@Component
export default class TravelCalculationForm extends Vue {
  public isLoading: boolean = false;
  public countries: Array<any> = [];
  public currencies: Array<any> = [];
  public travelPeriods: Array<any> = [];
  public travelPurposes: Array<Object> = travelPurposes;
  public travelAmounts: Array<Object> = travelAmounts;
  public travelCovidCoverages: Array<Object> = travelCovidCoverages;

  public form: TravelCalculateForm = new TravelCalculateForm();

  public goBack(): void {
    this.$router.push({ name: "travel" });
  }

  public addBirthDate(): void {
    this.form.birthDates.push(new Date());
  }

  public removeBirthDate(index: number): void {
    this.form.birthDates.splice(index, 1);
  }

  public calculate(): void {
    this.isLoading = true;

    Api.calculate(this.form)
      .then((response) => {
        this.$emit("calculated", this.form, response.data);
      })
      .catch((error) => EventBus.$emit(BusEvents.ERROR, error))
      .finally(() => this.isLoading = false);
  }

  private clear(): void {
  }

  private loadDictionaries(): void {
    let getCountries = Api.getCountries();
    let getCurrencies = Api.getCurrencies();
    let getPeriods = Api.getPeriods();

    this.isLoading = true;

    Promise
      .all([getCountries, getCurrencies, getPeriods])
      .then(([countryResponse, currencyResponse, periodResponse]) => {
        this.countries = countryResponse.data;
        this.currencies = currencyResponse.data;
        this.travelPeriods = periodResponse.data;
      })
      .catch((errors) => {
        errors.each((error: any) => EventBus.$emit(BusEvents.ERROR, error));
      })
      .finally(() => this.isLoading = false);
  }

  @Watch("form.period")
  onPropertyChanged(value: number, oldValue: number) {
    if (value) {
      alert(value);
    }
  }

  created(): void {
    this.clear();
    this.loadDictionaries();
  }
}
